import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead } from "./kit";

/// Guncelleme duyurusu: iki logolu tus. Numara yazmak yok.
/// iPhone: App Store'daki surum sunucu tarafindan okunur; tus acikken ondan eski
///   surumdeki herkese acilista "Yeni surum hazir" penceresi cikar.
/// Android: uygulamalarin bildirdigi en yeni surum (gelistirici derlemeleri haric)
///   takip edilir; tusa basinca o surum duyurulur.
/// Apple inceleme korumasi: App Store'dakinden YENI iPhone surumu (incelemedeki)
///   riskli ozellikleri gormez; Apple yayina alinca kendiliginden kalkar.

const AppleLogo = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
    <path d="M16.37 12.67c-.03-2.69 2.2-3.98 2.3-4.04-1.25-1.83-3.2-2.08-3.9-2.11-1.66-.17-3.24.98-4.08.98-.85 0-2.14-.96-3.52-.93-1.81.03-3.48 1.05-4.41 2.67-1.88 3.26-.48 8.08 1.35 10.73.9 1.29 1.96 2.75 3.36 2.7 1.35-.05 1.86-.87 3.49-.87 1.63 0 2.09.87 3.51.84 1.45-.03 2.37-1.32 3.25-2.62 1.03-1.5 1.45-2.95 1.47-3.03-.03-.01-2.82-1.08-2.85-4.3zM13.7 4.76c.74-.9 1.24-2.15 1.1-3.4-1.07.04-2.36.71-3.13 1.61-.69.79-1.29 2.07-1.13 3.29 1.19.09 2.41-.61 3.16-1.5z" />
  </svg>
);

const PlayLogo = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#34A853" d="M3.6 1.8 13.5 12 3.6 22.2c-.4-.2-.6-.6-.6-1.1V2.9c0-.5.2-.9.6-1.1z" />
    <path fill="#FBBC04" d="m17 8.4-3.5 3.6 3.5 3.6 4-2.3c.9-.5.9-1.8 0-2.3z" />
    <path fill="#4285F4" d="M3.6 22.2 13.5 12l3.5 3.6-11.6 6.7c-.6.3-1.3.3-1.8-.1z" />
    <path fill="#EA4335" d="M3.6 1.8c.5-.4 1.2-.4 1.8-.1L17 8.4 13.5 12z" />
  </svg>
);

const Kart = ({ renk, logo, baslik, durum, acik, tus, kapatTus, onBas, onKapat, busy }) => (
  <div style={{ flex: "1 1 300px", borderRadius: 20, padding: 20, background: renk, color: "#fff", boxShadow: "0 10px 30px rgba(0,0,0,.15)" }}>
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <div style={{ width: 56, height: 56, borderRadius: 16, background: "rgba(255,255,255,.14)", display: "grid", placeItems: "center" }}>{logo}</div>
      <div>
        <div style={{ fontSize: 18, fontWeight: 800 }}>{baslik}</div>
        <div style={{ fontSize: 13, opacity: 0.85, marginTop: 2 }}>{durum}</div>
      </div>
    </div>
    <button
      disabled={busy}
      onClick={onBas}
      style={{
        marginTop: 18, width: "100%", height: 52, border: 0, borderRadius: 14, fontSize: 16, fontWeight: 800, cursor: "pointer",
        background: acik ? "rgba(255,255,255,.18)" : "#fff", color: acik ? "#fff" : "#111827",
      }}
    >
      {tus}
    </button>
    {acik && (
      <button
        disabled={busy}
        onClick={onKapat}
        style={{ marginTop: 8, width: "100%", height: 38, border: 0, borderRadius: 10, background: "transparent", color: "#fff", opacity: 0.8, cursor: "pointer" }}
      >
        {kapatTus}
      </button>
    )}
  </div>
);

const AppVersion = () => {
  const [cfg, setCfg] = useState(null);
  const [iosStore, setIosStore] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.config().then((r) => {
      if (!r?.status) return;
      setCfg(r.config);
      setIosStore(r.iosStore || "");
    });
  }, []);

  const kaydet = async (body, tamam) => {
    setBusy(true);
    const r = await api.saveConfig(body);
    setBusy(false);
    setMsg(r?.status ? tamam : r?.message || "Kaydedilemedi");
    if (r?.status) setCfg(r.config);
  };

  if (!cfg) return <PageHead title="Uygulama sürümü" sub="Yükleniyor…" />;

  const iosAcik = cfg.iosUpdateOn === true;
  const gorulen = Number(cfg.androidSeenBuild) || 0;
  const duyurulan = Number(cfg.androidLatestBuild) || 0;
  const androidAcik = duyurulan > 0;
  const koruma = cfg.appleReviewGuard !== false;

  return (
    <>
      <PageHead
        title="Uygulama sürümü"
        sub="Mağaza yeni sürümü yayına alınca ilgili tuşa bas. Eski sürümü kullananlara uygulama açılışında 'Yeni sürüm hazır' penceresi çıkar."
      />

      <div style={{ display: "flex", flexWrap: "wrap", gap: 16, maxWidth: 820 }}>
        <Kart
          renk="linear-gradient(135deg,#1f2937,#000)"
          logo={<AppleLogo />}
          baslik="App Store"
          durum={`Mağazada yayında: ${iosStore || "okunuyor…"}`}
          acik={iosAcik}
          tus={iosAcik ? "Duyuru açık ✓" : "Güncelleme geldi · Duyur"}
          kapatTus="Duyuruyu kapat"
          busy={busy}
          onBas={() => !iosAcik && kaydet({ iosUpdateOn: true }, "iPhone duyurusu açıldı.")}
          onKapat={() => kaydet({ iosUpdateOn: false }, "iPhone duyurusu kapatıldı.")}
        />
        <Kart
          renk="linear-gradient(135deg,#0f766e,#064e3b)"
          logo={<PlayLogo />}
          baslik="Google Play"
          durum={`Görülen en yeni sürüm: ${gorulen || "—"}${duyurulan ? ` · duyurulan: ${duyurulan}` : ""}`}
          acik={androidAcik && duyurulan >= gorulen}
          tus={androidAcik && duyurulan >= gorulen ? "Duyuru açık ✓" : "Güncelleme geldi · Duyur"}
          kapatTus="Duyuruyu kapat"
          busy={busy}
          onBas={() =>
            gorulen
              ? kaydet({ androidLatestBuild: gorulen }, `Android duyurusu açıldı (sürüm ${gorulen}).`)
              : setMsg("Henüz yeni sürümü açan kimse yok. Önce kendi telefonunda Play Store'dan güncelle, sonra bas.")
          }
          onKapat={() => kaydet({ androidLatestBuild: 0 }, "Android duyurusu kapatıldı.")}
        />
      </div>

      <div
        style={{
          maxWidth: 820, marginTop: 18, padding: 18, borderRadius: 16,
          background: koruma ? "#ECFDF5" : "#FEF2F2", border: `1px solid ${koruma ? "#A7F3D0" : "#FECACA"}`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 15 }}>🛡️ Apple inceleme koruması {koruma ? "AÇIK" : "KAPALI"}</div>
            <div style={{ fontSize: 13, color: "#374151", marginTop: 4, lineHeight: 1.5 }}>
              App Store'dakinden ({iosStore || "…"}) yeni iPhone sürümü — yani Apple'ın incelediği sürüm — oyunları, yetkili bayiyi,
              şans çantasını, maaş politikasını ve şanslı hediyeleri görmez; profil fotoğrafı zorunlu olmaz. Android ve mevcut
              kullanıcılar etkilenmez. Apple yayına alınca kendiliğinden kalkar; açık bırakabilirsin.
            </div>
          </div>
          <button
            className={koruma ? "btn btn-light" : "btn btn-primary"}
            disabled={busy}
            onClick={() => kaydet({ appleReviewGuard: !koruma }, koruma ? "Koruma kapatıldı." : "Koruma açıldı.")}
          >
            {koruma ? "Kapat" : "Aç"}
          </button>
        </div>
      </div>

      {msg && <div style={{ marginTop: 14, fontSize: 14, fontWeight: 600 }}>{msg}</div>}

      {/* herkesi oturumdan cikar: 1.5.8 (75) ve sonrasinda calisir */}
      <div className="card" style={{ marginTop: 24, maxWidth: 820, border: "1px solid #FECACA" }}>
        <div className="card-body">
          <h6 style={{ color: "#B91C1C", margin: 0 }}>Herkesi oturumdan çıkar</h6>
          <p style={{ fontSize: 13, color: "#6B7280", margin: "6px 0 10px" }}>
            Uygulamayı açan herkes bir kez çıkış yapar ve giriş ekranına düşer. Hesaplar, coinler ve veriler silinmez; aynı yöntemle girince
            kaldıkları yerden devam ederler. Sadece 1.5.8 (75) ve sonrası etkilenir, eski sürümdekiler güncelleyince çıkar.
          </p>
          <button
            className="btn btn-outline-danger"
            onClick={async () => {
              if (!window.confirm("Herkes bir sonraki açılışta çıkış yapacak. Emin misin?")) return;
              const r = await api.forceLogout();
              window.alert(r?.message || (r?.status ? "Tamam" : "Yapılamadı"));
            }}
          >
            Herkesi çıkar
          </button>
        </div>
      </div>
    </>
  );
};

export default AppVersion;
